import { useMemo } from 'react';
import { getParsedDate } from './TimeSlotPicker.helpers';
export const useParsedDate = (date, timezone) => {
    return useMemo(() => {
        return getParsedDate(date, timezone);
    }, [date, timezone]);
};
